import script from "./tool-use-block.vue?vue&type=script&setup=true&lang=js"
export * from "./tool-use-block.vue?vue&type=script&setup=true&lang=js"

import "./tool-use-block.vue?vue&type=style&index=0&id=07489193&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07489193"]])

export default __exports__